module.exports = __webpack_public_path__ + "img/jianzhu_bg.87d0e7f9.png";